import { Component, OnInit } from '@angular/core';
import { AppInfo, AppInfoService } from '../../services/app-info.service';

@Component({
  selector: 'app-about-dialog',
  templateUrl: './about-dialog.component.html',
  styleUrls: ['./about-dialog.component.scss'],
})
export class AboutDialogComponent implements OnInit {
  info: AppInfo;
  backendBuild: string | null = null;
  loadingBackend = true;

  constructor(private appInfo: AppInfoService) {}

  ngOnInit(): void {
    this.info = this.appInfo.info;
    this.appInfo.getBackendBuildTime().subscribe(build => {
      this.backendBuild = build;
      this.loadingBackend = false;
    });
  }
}
